export default __webpack_public_path__ + "static/media/icon_vacuna.b23b62da.png";